import WebApp from '@twa-dev/sdk';
import numbro from 'numbro';
import { throttle } from 'lodash-es';
import { user } from '@/services/store';
import LevelAvatarLv1 from '@/assets/images/pet-lv1.png';
import LevelAvatarLv2 from '@/assets/images/pet-lv2.png';
import LevelAvatarLv3 from '@/assets/images/pet-lv3.png';
import LevelAvatarLv4 from '@/assets/images/pet-lv4.png';
import LevelAvatarLv5 from '@/assets/images/pet-lv5.png';
import LevelAvatarLv6 from '@/assets/images/pet-lv6.png';
import LevelAvatarLv7 from '@/assets/images/pet-lv7.png';
import LevelAvatarLv8 from '@/assets/images/pet-lv8.png';
import LevelAvatarLv9 from '@/assets/images/pet-lv9.png';
import LevelAvatarLv10 from '@/assets/images/pet-lv10.png';
import { pop } from '@/components/Pop';
import { toast } from '@/components/Toast';

export const copyActionToast = throttle(() => toast.success('Copy Success'), 3000, { trailing: false });

export const tokenParamFromSdk = () => {
  const idToken =
    WebApp.initData ||
    import.meta.env.VITE_BOT_LOCALE_TG_TOKEN ||
    'query_id=AAFLo-c4AwAAAEuj5zjHIdhf&user=%7B%22id%22%3A7397155659%2C%22first_name%22%3A%22Tim%22%2C%22last_name%22%3A%22%22%2C%22language_code%22%3A%22zh-hans%22%2C%22allows_write_to_pm%22%3Atrue%7D&auth_date=1722460733&hash=2eba33d6e83a05feeb094fa6c959188e62a94076f05bbde83381e160f8662457';

  return { idToken };
};

/*千分位格式化*/
export const formatNum = (num: number | string, decimalPlaces?: number) => {
  const n = Number(num);
  return numbro(n).format({
    thousandSeparated: true,
    ...(decimalPlaces !== undefined && { mantissa: decimalPlaces, trimMantissa: true }), // 根据参数保留小数位
  });
};

export const setupTG = () => {
  WebApp.BackButton.show();
  WebApp.BackButton.onClick(() => {
    if (pop.list.length > 0) {
      try {
        pop.pop();
        return;
      } catch {}
    }

    window.history.back();
  });
};

export function formatTime(time: number): string {
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = time % 60;

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export function getStartParams(): string {
  // 链接中携带的邀请码, 之前是加密的json串包含inviteCode和path, 现在只有inviteCode的值
  const tgParam = WebApp.initDataUnsafe.start_param || '';
  try {
    // 兼容之前的json
    const params = JSON.parse(window.atob(tgParam)) || {};
    return params.inviteCode || tgParam;
  } catch {
    return tgParam;
  }
}

const inviteText = `Play with me on the #CocoRush game, you just open the telegram to adopt your Coco for free, sign in through my link and you may get $BC AirDrop!
💰+10K Coins new-user bonus
💸+20K Coins if you have TG premium`;

/**
 * tg平台文字在链接后面, twitter文字在前面(暂时还没twitter的分享需求), 不传平台只有链接(复制时可以这样用)
 */
export function genInviteLink(platform?: 'tg' | 'twitter') {
  const url = import.meta.env.VITE_BOT_ADDRESS + '?startapp=' + user.inviteCode;

  if (platform === 'tg') {
    return url + window.encodeURIComponent('\n\n' + inviteText);
  } else if (platform === 'twitter') {
    return 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(inviteText + '\n' + url);
  }

  return url;
}

export function capitalizeFirstLetter(word: string) {
  if (!word) return word; // 处理空字符串或非字符串输入
  return word.charAt(0).toUpperCase() + word.slice(1);
}

export function getUserAvatar(level: number) {
  if (level <= 1) {
    return LevelAvatarLv1;
  } else if (level === 2) {
    return LevelAvatarLv2;
  } else if (level === 3) {
    return LevelAvatarLv3;
  } else if (level === 4) {
    return LevelAvatarLv4;
  } else if (level === 5) {
    return LevelAvatarLv5;
  } else if (level === 6) {
    return LevelAvatarLv6;
  } else if (level === 7) {
    return LevelAvatarLv7;
  } else if (level === 8) {
    return LevelAvatarLv8;
  } else if (level === 9) {
    return LevelAvatarLv9;
  } else if (level >= 10) {
    return LevelAvatarLv10;
  }
}

/**
 * 通用排序函数，用于排序对象数组
 * @param array - 需要排序的数组
 * @param key - 用于排序的键名
 * @param ascending - 是否升序排序（默认升序）
 * @returns 排序后的数组
 */
export function sortByKey<T>(array: T[], key: keyof T, ascending: boolean = true): T[] {
  return array.sort((a, b) => {
    if (a[key] < b[key]) return ascending ? -1 : 1;
    if (a[key] > b[key]) return ascending ? 1 : -1;
    return 0;
  });
}


export default {};
